import { render } from "./tournament-players-prizes.vue?vue&type=template&id=0dc40a65&ts=true"
import script from "./tournament-players-prizes.vue?vue&type=script&lang=ts"
export * from "./tournament-players-prizes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Reports/tournament-players-prizes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dc40a65"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dc40a65', __exports__)) {
    api.reload('0dc40a65', __exports__)
  }
  
  module.hot.accept("./tournament-players-prizes.vue?vue&type=template&id=0dc40a65&ts=true", () => {
    api.rerender('0dc40a65', render)
  })

}


export default __exports__